import { render, staticRenderFns } from "./purchasea-tui.vue?vue&type=template&id=7b431cb5&scoped=true&"
import script from "./purchasea-tui.vue?vue&type=script&lang=js&"
export * from "./purchasea-tui.vue?vue&type=script&lang=js&"
import style0 from "./purchasea-tui.vue?vue&type=style&index=0&id=7b431cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b431cb5",
  null
  
)

export default component.exports